export const MAX_TRIES = 6;

export const TIER_TEXT_COLOR = {
  exact: "#2e8d3e", hot: "#c7281a", warmer: "#d65a2c",
  warm: "#cc8b2a", colder: "#5e93bf", cold: "#3c7bb0", supercold: "#1f3f7a"
};

export function hintFor(guess, actual) {
  if (guess === actual) return { cls: "correct", symbol: "✓", text: "Exact", tier: "exact" };
  const cls = guess > actual ? "too-high" : "too-low";
  const symbol = guess > actual ? "▼" : "▲";
  const diff = Math.abs(guess - actual);
  const pct = diff / actual;
  let text, tier;
  if ((actual >= 100 && diff <= 10) || pct <= 0.05) { tier = "hot";        text = "Hot"; }
  else if (pct <= 0.12) { tier = "warmer";    text = "Warmer"; }
  else if (pct <= 0.22) { tier = "warm";      text = "Warm"; }
  else if (pct <= 0.40) { tier = "colder";    text = "Colder"; }
  else if (pct <= 0.70) { tier = "cold";      text = "Cold"; }
  else                  { tier = "supercold"; text = "Super Cold"; }
  return { cls, symbol, text, tier };
}

export function arrowSvg(cls) {
  const up    = `M 14 1 L 27 14 L 20 14 L 20 33 L 8 33 L 8 14 L 1 14 Z`;
  const down  = `M 14 33 L 27 20 L 20 20 L 20 1 L 8 1 L 8 20 L 1 20 Z`;
  const check = `M 3 17 L 11 25 L 25 7 L 22 4 L 11 15 L 6 10 Z`;
  let path, stroke, grad;
  if (cls === "too-high")     { path = down;  grad = "grad-red";   stroke = "#5a1510"; }
  else if (cls === "too-low") { path = up;    grad = "grad-green"; stroke = "#0f3015"; }
  else                        { path = check; grad = "grad-green"; stroke = "#0f3015"; }
  return `<svg viewBox="0 0 28 34" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="${path}" fill="url(#${grad})" stroke="${stroke}" stroke-width="1" stroke-linejoin="round"/>
    <path d="${path}" fill="url(#grad-hi)" style="mix-blend-mode: screen" />
  </svg>`;
}
